import { AuthService } from './auth.service';

import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivate
} from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  privileges = false;
  perfiles = [{ tpperfil: 601, page: 'Administrador' },
  { tpperfil: 105, page: 'Gobernacion' },
  ];
  test: any;

  constructor(private _auth: AuthService, private router: Router) {
    //super(router, keycloakAngular);
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {


    if (this._auth.isTokenExpired(this._auth.getToken())) {
      this._auth.logout();
    }
    
    if (this._auth.autenticado()) {

      this.router.navigate(['login'], { queryParams: { returnUrl: state.url } });

      return false;
    } else {
      if (this.canAccess(next)) {
        return true;
      } else {


        this.router.navigate([this.found(this._auth.getroleToken())]);
      }
    }

  }
  canAccess(next) {

    this.privileges = false;

    next.data.privileges.forEach(element => {
      if (Number(element) === this._auth.getroleToken()) {
        this.privileges = true;
      }
    });

    return this.privileges;
  }


  found(tpperfil) {

    this.perfiles.forEach(element => {

      if (Number(element.tpperfil) === tpperfil) {
        this.test = element.page;
      }
    });
    return this.test;
  }
}
